import { initI18n } from '@/i18n/translate-utils'
import { registerChameleonComponents } from '@/chameleon-register'
import { registry, registerComponents } from '@/components/components-registry'
import { initializeGallery } from '@/utils/gallery-app-utils'

void (async () => {
  await initI18n(navigator.language)
  registerChameleonComponents()
  registerComponents(registry)

  initializeGallery()
})()
